import React from "react";
import { cn } from "@/lib/utils";

interface SheetScrollableContentProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const SheetScrollableContent = React.forwardRef<
  HTMLDivElement,
  SheetScrollableContentProps
>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex-1 overflow-y-auto", className)}
    style={{ marginRight: "-24px", paddingRight: "24px" }}
    {...props}
  >
    {children}
  </div>
));
SheetScrollableContent.displayName = "SheetScrollableContent";

export { SheetScrollableContent };
